"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3816],{

/***/ 48154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ErrorLabel_ErrorLabel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/ErrorLabel/ErrorLabel.js






const ErrorLabelText = (param)=>/*#__PURE__*/ {
    let { className ="" , children , ...props } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: (0,classes/* classes */.S)("error-label__wrap", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "error-label__wrap-text",
            children: children
        })
    });
};
ErrorLabelText.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
const ErrorLabel = (param)=>/*#__PURE__*/ {
    let { className ="" , children , ...props } = param;
    return (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        Tag: "span",
        className: (0,classes/* classes */.S)("field--error", className),
        ...props,
        children: children
    });
};
ErrorLabel.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
ErrorLabel.Text = ErrorLabelText;
/* harmony default export */ var ErrorLabel_ErrorLabel = ((0,pureFC/* default */.Z)(ErrorLabel));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/ErrorLabel/index.js



/***/ }),

/***/ 4711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FieldHint_FieldHint; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FieldHint/FieldHint.js





const FieldHint = (param)=>/*#__PURE__*/ {
    let { isActive =false , className , ...props } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: (0,classes/* classes */.S)("field__hint", isActive && "field__hint--active", className),
        ...props
    });
};
FieldHint.propTypes = {
    isActive: prop_types.bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var FieldHint_FieldHint = ((0,pureFC/* default */.Z)(FieldHint));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FieldHint/index.js



/***/ }),

/***/ 22950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Form_Form; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Form/Form.js





const Form = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)("form", {
        className: (0,classes/* classes */.S)("form form--stacked", className),
        ...props
    });
};
Form.propTypes = {
    className: prop_types.string
};
/* harmony default export */ var Form_Form = ((0,pureFC/* default */.Z)(Form));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Form/index.js



/***/ }),

/***/ 26522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FormField_FormField; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/FormGroup/index.js + 1 modules
var FormGroup = __webpack_require__(39566);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Label/index.js + 1 modules
var Label = __webpack_require__(76223);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/FieldHint/index.js + 1 modules
var FieldHint = __webpack_require__(4711);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ErrorLabel/index.js + 1 modules
var ErrorLabel = __webpack_require__(48154);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Input/index.js + 2 modules
var Input = __webpack_require__(6470);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FieldLink/FieldLink.js





const FieldLink = (param)=>/*#__PURE__*/ {
    let { className , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("field__link", className),
        ...props
    });
};
FieldLink.propTypes = {
    className: (prop_types_default()).string
};
/* harmony default export */ var FieldLink_FieldLink = ((0,pureFC/* default */.Z)(FieldLink));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FieldLink/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/predicates.js
var predicates = __webpack_require__(53863);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var props_sizing = __webpack_require__(88270);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FormField/FormField.js














const FormField = (param)=>/*#__PURE__*/ {
    let { label , required , hint , error =null , link , Control =Input/* default */.Z , children , fieldClassName , inverted =false , onLabelClick , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sizing ={
        ...props_sizing/* sizingProps */.H6
    } , ...props } = param;
    return (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
        required: required,
        className: fieldClassName,
        error: error,
        spacing: spacing,
        utility: utility,
        sizing: sizing,
        children: [
            (0,predicates/* isString */.HD)(label) ? // eslint-disable-next-line react/destructuring-assignment
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                htmlFor: props.id,
                inverted: inverted,
                onClick: onLabelClick,
                children: label
            }) : label,
            Control && /*#__PURE__*/ (0,jsx_runtime.jsx)(Control, {
                ...props,
                error: error,
                children: children
            }),
            !Control && children,
            (0,predicates/* isString */.HD)(hint) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldHint/* default */.Z, {
                children: hint
            }) : hint,
            (0,predicates/* isString */.HD)(error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel/* default */.Z, {
                children: error
            }) : error,
            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldLink_FieldLink, {
                children: link
            })
        ]
    });
};
FormField.propTypes = {
    id: prop_types.string,
    label: prop_types.node,
    required: prop_types.bool,
    hint: prop_types.node,
    error: prop_types.node,
    link: prop_types.node,
    Control: prop_types.elementType,
    children: prop_types.node,
    fieldClassName: prop_types.string,
    inverted: prop_types.bool,
    onLabelClick: prop_types.func,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sizing: props_sizing/* sizingPropTypes */.bm
};
/* harmony default export */ var FormField_FormField = ((0,pureFC/* default */.Z)(FormField));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FormField/index.js



/***/ }),

/***/ 39566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FormGroup_FormGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var props_sizing = __webpack_require__(88270);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FormGroup/FormGroup.js








const FormGroup = (param)=>/*#__PURE__*/ {
    let { isCheckBox =false , isRadio =false , required , error =false , className , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sizing ={
        ...props_sizing/* sizingProps */.H6
    } , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("field", isCheckBox && "field-checkbox", isRadio && "field-radio", required && "field--required", error && "field--error", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), ...(0,props_sizing/* sizingClassName */.rs)(sizing), className),
        ...props
    });
};
FormGroup.propTypes = {
    isCheckBox: prop_types.bool,
    isRadio: prop_types.bool,
    required: prop_types.bool,
    error: prop_types.node,
    className: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sizing: props_sizing/* sizingPropTypes */.bm
};
/* harmony default export */ var FormGroup_FormGroup = ((0,pureFC/* default */.Z)(FormGroup));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/FormGroup/index.js



/***/ }),

/***/ 6470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Input_Input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/invariant.js
/**
 * @param {boolean} condition
 * @param {string} message
 */ const invariant = (condition, message)=>{
    if (false) {}
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Input/Input.js










const Input = (param)=>{
    let { type ="text" , hideInputNumberArrows =true , maxLength =250 , error , className , forwardRef , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    invariant(/^(button|reset|submit)$/.test(type), "Use <Button /> component instead of Input");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
        type: type,
        maxLength: maxLength,
        ref: forwardRef,
        className: (0,classes/* classes */.S)("field__input", "field__".concat(type), type === "number" && hideInputNumberArrows && "hidden-arrows", error && "field--error", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Input.propTypes = {
    type: (0,prop_types.oneOf)([
        "email",
        "file",
        "hidden",
        "number",
        "password",
        "range",
        "search",
        "tel",
        "text",
        "url"
    ]),
    className: prop_types.string,
    maxLength: prop_types.number,
    error: (0,prop_types.oneOfType)([
        prop_types.bool,
        prop_types.string,
        prop_types.node
    ]),
    hideInputNumberArrows: prop_types.bool,
    forwardRef: forward_ref/* default */.Z,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Input_Input = ((0,pureFC/* default */.Z)(Input));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Input/index.js



/***/ }),

/***/ 76223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Label_Label; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Label/Label.js
/* eslint-disable jsx-a11y/label-has-associated-control */ 




const Label = (param)=>/*#__PURE__*/ {
    let { className ="" , uppercase =true , width , inverted =false , ...props } = param;
    return (0,jsx_runtime.jsx)("label", {
        className: (0,classes/* classes */.S)("field__label", !uppercase && "field__label--transform-none", inverted && "field__label--inverted", width && "w-".concat(width), className),
        ...props
    });
};
Label.propTypes = {
    uppercase: prop_types.bool,
    width: prop_types.number,
    className: prop_types.string,
    inverted: prop_types.bool
};
/* harmony default export */ var Label_Label = ((0,pureFC/* default */.Z)(Label));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Label/index.js



/***/ }),

/***/ 3816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gN": function() { return /* reexport */ SmartForm_Field; },
  "ZP": function() { return /* binding */ smart_react_SmartForm; }
});

// UNUSED EXPORTS: FormContext, ValueOf

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Form/index.js + 1 modules
var Form = __webpack_require__(22950);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/context.js

/* harmony default export */ var context = (/*#__PURE__*/(0,react.createContext)());

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/FormField/index.js + 3 modules
var FormField = __webpack_require__(26522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/predicates.js
var predicates = __webpack_require__(53863);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/events/handlers.js
var handlers = __webpack_require__(28763);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ErrorLabel/index.js + 1 modules
var ErrorLabel = __webpack_require__(48154);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/renders/renderError.js




const renderError = function(error) {
    let render = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fn/* idX */.Yr;
    return error && (Array.isArray(error) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel/* default */.Z, {
        children: error.map((e)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel/* default.Text */.Z.Text, {
                children: render(e)
            }, e))
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorLabel/* default.Text */.Z.Text, {
            children: render(error)
        })
    }));
};
/* harmony default export */ var renders_renderError = (renderError);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/Field.js










const MemoizedFormField = /*#__PURE__*/ react.memo(FormField/* default */.Z);
function Field(param) {
    let { name , parseEvent , onChange , onBlur , forwardRef , label , hint , error , setState , animate =false , fieldClassName ="" , ...props } = param;
    const [isFocus, setFocus] = (0,react.useState)(false);
    const { form , register , update , touch , errors , textRender , options  } = (0,react.useContext)(context);
    const { blurDelay  } = options;
    const fieldRef = (0,react.useRef)(null);
    const value = (0,react.useMemo)(()=>{
        return form[name];
    }, [
        form
    ]);
    const blurAsyncComposer = (0,react.useMemo)(()=>blurDelay != null ? handlers/* asyncHandleWith.m */.aV.m(blurDelay) : handlers/* handleWith.m */.Gy.m, [
        blurDelay
    ]);
    const blurHandler = handlers/* handleWith.m */.Gy.m(onBlur, touch(name));
    const blurHandlerAsync = blurAsyncComposer(onBlur, touch(name));
    const handleBlur = (0,react.useCallback)((event)=>{
        setFocus(false);
        return event.relatedTarget != null ? blurHandlerAsync(event) : blurHandler(event);
    }, [
        blurHandlerAsync,
        blurHandler
    ]);
    const handleFocus = (0,react.useCallback)(()=>{
        setFocus(true);
    }, []);
    const isError = (0,react.useMemo)(()=>{
        return error || errors[name];
    }, [
        error,
        errors
    ]);
    const fieldAnimateClassName = (0,react.useMemo)(()=>{
        return [
            animate && "field-animate",
            animate && (isFocus || value) && "field-animate--focused",
            animate && isError && "field-animate--error"
        ];
    }, [
        value,
        isError,
        isFocus
    ]);
    const handleLabelClick = (0,react.useCallback)(()=>{
        if (!isFocus) {
            fieldRef.current.focus();
            setFocus(true);
        }
    }, [
        isFocus,
        setFocus,
        form
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedFormField, {
        ...props,
        fieldClassName: (0,classes/* classes */.S)(...fieldAnimateClassName, fieldClassName),
        name: name,
        hint: (0,predicates/* isString */.HD)(hint) ? textRender(hint) : hint,
        label: (0,predicates/* isString */.HD)(label) ? textRender(label) : label,
        value: form[name],
        onChange: handlers/* handleWith.m */.Gy.m(onChange, update(setState || name, parseEvent)),
        onFocus: handleFocus,
        onBlur: handleBlur,
        forwardRef: handlers/* composeRefs.m */.FE.m(forwardRef, register(name), fieldRef),
        error: renders_renderError(error || errors[name], textRender),
        onLabelClick: handleLabelClick
    });
}
Field.propTypes = {
    name: prop_types.string.isRequired,
    fieldClassName: prop_types.string,
    setState: prop_types.func,
    parseEvent: prop_types.func,
    onChange: prop_types.func,
    onBlur: prop_types.func,
    forwardRef: forward_ref/* default */.Z,
    label: prop_types.node,
    hint: prop_types.node,
    animate: prop_types.bool,
    error: (0,prop_types.oneOfType)([
        prop_types.string,
        (0,prop_types.arrayOf)(prop_types.string)
    ])
};
/* harmony default export */ var SmartForm_Field = (/*#__PURE__*/react.memo(Field));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/lists/set.js
const indexOf = (list, item)=>list.indexOf(item);
/**
 * Adds item to list if list doesn't contain the item, otherwise returns the same list
 *
 * @type {<T>(list?: T[], item: T) => T[]}
 */ const include = function() {
    let list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], item = arguments.length > 1 ? arguments[1] : void 0;
    return list.includes(item) ? list : [
        ...list,
        item
    ];
};
/**
 * Removes item from list if item is in the list, otherwise returns the same list
 *
 * @type {<T>(list?: T[], item: T) => T[]}
 */ const exclude = function() {
    let list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], item = arguments.length > 1 ? arguments[1] : void 0;
    const index = list.length > 0 ? indexOf(list, item) : -1;
    if (index < 0) return list;
    return [
        ...list.slice(0, index),
        ...list.slice(index + 1)
    ];
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/memo/index.js + 1 modules
var memo = __webpack_require__(27639);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/events/readers.js
const targetValue = (param)=>{
    let { target  } = param;
    return target.value;
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useUnmounted.js
var useUnmounted = __webpack_require__(23740);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/hook.js







const merge = (payload)=>(state)=>({
            ...state,
            ...payload
        });
const pack = (field)=>(value)=>({
            [field]: value
        });
const inc = function(x) {
    let delta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return x + delta;
};
const toErrorObject = (errors)=>(field)=>errors[field] // is field invalid
         ? {
            [field]: errors[field]
        } // creating an object
         : null;
const fieldsToErrors = (fields, errors)=>Object.assign({}, ...fields.map(toErrorObject(errors)));
const findInvalidControl = (controls, errors)=>Array.from(controls).find((param)=>{
        let [field, element] = param;
        return errors[field] && element;
    });
const add = (value)=>(list)=>include(list, value);
const del = (value)=>(list)=>exclude(list, value);
function useSmartForm(initialState, validateForm, formAction, stateRef, options) {
    const isUnmountedRef = (0,useUnmounted/* default */.Z)();
    const [form, setFormStateUnsafe] = (0,react.useState)(()=>initialState);
    const [validations, setValidationsUnsafe] = (0,react.useState)(0);
    const [touched, setTouchedUnsafe] = (0,react.useState)([]);
    const validationResult = (0,react.useRef)();
    const controls = (0,react.useRef)(new Map());
    const setFormState = (0,useUnmounted/* useIfMounted */.n)(setFormStateUnsafe, isUnmountedRef);
    const setValidations = (0,useUnmounted/* useIfMounted */.n)(setValidationsUnsafe, isUnmountedRef);
    const setTouched = (0,useUnmounted/* useIfMounted */.n)(setTouchedUnsafe, isUnmountedRef);
    (0,handlers/* setRef */.k$)(stateRef, form);
    var ref;
    const optionsContext = (0,react.useMemo)(()=>{
        return {
            blurDelay: (ref = options === null || options === void 0 ? void 0 : options.blurDelay) !== null && ref !== void 0 ? ref : null
        };
    }, [
        options
    ]);
    const touch = (0,react.useCallback)((0,memo/* memo1 */.nJ)((field)=>()=>setTouched(add(field))), []);
    const untouch = (0,react.useCallback)((0,memo/* memo1 */.nJ)((field)=>()=>setTouched(del(field))), []);
    const untouchForm = (0,react.useCallback)(()=>setTouched([]), []);
    const update = (0,react.useMemo)(()=>(0,memo/* memo1 */.nJ)(function(field) {
            let parseEvent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : targetValue;
            return typeof field === "function" ? (0,fn/* compose */.qC)(setFormState, (value)=>(state)=>field(state, value), parseEvent) : (0,fn/* compose */.qC)(setFormState, merge, pack(field), parseEvent);
        }), []);
    const register = (0,react.useMemo)(()=>(0,memo/* memo1 */.nJ)((field)=>(element)=>{
                controls.current.set(field, element);
            }), []);
    const resetValidations = (0,react.useCallback)(()=>setValidations(0), []);
    validationResult.current = (0,react.useMemo)(()=>validateForm(form), [
        form,
        validateForm
    ]);
    validationResult.current.state = form;
    const { isValid , errors  } = validationResult.current;
    const touchedErrors = (0,react.useMemo)(()=>fieldsToErrors(touched, errors), [
        errors,
        touched
    ]);
    const visibleErrors = validations > 0 ? errors : touchedErrors;
    const submit = (0,react.useCallback)((event)=>{
        const formState = validationResult.current;
        event.preventDefault();
        if (!formState.isValid) {
            setValidations(inc);
            return;
        }
        resetValidations();
        untouchForm();
        formAction(formState.state);
    }, []);
    const reset = (0,react.useCallback)(()=>{
        resetValidations();
        untouchForm();
        setFormState(initialState);
    }, [
        initialState
    ]);
    (0,react.useEffect)(()=>{
        if (validations === 0) return;
        const [, control] = findInvalidControl(controls.current, errors) || [];
        if (control == null) return;
        control.focus();
        if (control.offsetParent === null) control.scrollIntoView();
    }, [
        validations
    ]);
    return {
        form,
        setState: setFormState,
        isValid,
        formErrors: errors,
        errors: visibleErrors,
        resetValidations,
        touch,
        untouch,
        untouchForm,
        register,
        update,
        submit,
        touched,
        reset,
        options: optionsContext
    };
}
/* harmony default export */ var hook = (useSmartForm);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/ValueOf.js



function ValueOf(param) {
    let { name , children  } = param;
    const { form , update , register , touch , errors , formErrors  } = react.useContext(context);
    return typeof children === "function" ? children({
        value: form[name],
        update: update(name),
        register: register(name),
        touch: touch(name),
        error: errors[name],
        formError: formErrors[name]
    }) : form[name];
}
ValueOf.propTypes = {
    name: prop_types.string.isRequired,
    children: prop_types.func
};
/* harmony default export */ var SmartForm_ValueOf = (ValueOf);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/validation/index.js + 7 modules
var validation = __webpack_require__(69340);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/useWatch.js



const isNotEqual = (0,validation/* not */.ff)(Object.is);
function useWatch(value, callback) {
    let condition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : isNotEqual;
    const valueRef = react.useRef(value);
    react.useEffect(()=>{
        if ((0,fn/* isFunc */.Wl)(callback) && condition(value, valueRef.current)) {
            callback(value, valueRef.current);
        }
        valueRef.current = value;
    }, [
        value
    ]);
}
/* harmony default export */ var SmartForm_useWatch = (useWatch);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/index.js











function SmartForm(param) {
    let { initialState , validateForm , action , textRender =fn/* idX */.Yr , onTouched , onChange , stateRef , apiRef , blurDelay , ...props } = param;
    const formData = hook(initialState, validateForm, action, stateRef, {
        blurDelay
    });
    (0,handlers/* setRef */.k$)(apiRef, formData);
    SmartForm_useWatch(formData.touched.length, onTouched, (next, prev)=>next > prev);
    (0,react.useEffect)(()=>typeof onChange === "function" && formData.touched.length > 0 ? onChange(formData.form) : undefined, [
        formData.form
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context.Provider, {
        value: {
            ...formData,
            textRender
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
            ...props,
            onSubmit: formData.submit,
            noValidate: true
        })
    });
}
SmartForm.propTypes = {
    initialState: prop_types.object,
    validateForm: prop_types.func,
    action: prop_types.func,
    textRender: prop_types.func,
    onTouched: prop_types.func,
    onChange: prop_types.func,
    stateRef: (0,prop_types.oneOfType)([
        prop_types.func,
        (0,prop_types.shape)({
            current: prop_types.any
        })
    ]),
    apiRef: (0,prop_types.oneOfType)([
        prop_types.func,
        (0,prop_types.shape)({
            current: prop_types.any
        })
    ]),
    blurDelay: prop_types.number
};
SmartForm.Field = SmartForm_Field;
SmartForm.ValueOf = SmartForm_ValueOf;
SmartForm.context = context;

/* harmony default export */ var smart_react_SmartForm = (SmartForm);


/***/ })

}]);